import { CustomProjectEntity } from '@entities/CustomProject/Types';
import css from './RenderProjectTableRow.module.css';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { DesktopProjectTableRow } from '@modules/BillOfMaterials/Components/BillOfMaterials/ProjectsList/ProjectListTable/RenderProjectTableRow/DesktopProjectTableRow/DesktopProjectTableRow';
import { MobileProjectTableRow } from '@modules/BillOfMaterials/Components/BillOfMaterials/ProjectsList/ProjectListTable/RenderProjectTableRow/MobileProjectTableRow/MobileProjectTableRow';

interface RenderProjectTableRowProps {
    customProjects: CustomProjectEntity[];
}

export const RenderProjectTableRow: React.FC<RenderProjectTableRowProps> = ({
    customProjects,
}) => {
    const [isDesktop, isTablet, isMobile] = useMediaType();

    return (
        <div className={css.wrapper}>
            {customProjects.map((project, index) =>
                isDesktop ? (
                    <DesktopProjectTableRow
                        project={project}
                        key={project.id}
                    />
                ) : (
                    <MobileProjectTableRow project={project} key={project.id} />
                )
            )}
        </div>
    );
};
